import { render } from "./PressedLoose.vue?vue&type=template&id=6b2e2df4"
import script from "./PressedLoose.vue?vue&type=script&lang=js"
export * from "./PressedLoose.vue?vue&type=script&lang=js"

import "./PressedLoose.vue?vue&type=style&index=0&id=6b2e2df4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__